"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

var _ThemeProvider = require("../../theme/ThemeProvider");

var _style = _interopRequireDefault(require("./style"));

var _Button = _interopRequireDefault(require("../Button"));

var _classnames = _interopRequireDefault(require("classnames"));

var useStyles = (0, _ThemeProvider.createUseStyles)(_style["default"]);

var formatSeconds = function formatSeconds(seconds) {
  var mins = String(Math.floor(seconds / 60));
  var secs = String(seconds % 60);
  return "".concat(mins.padStart(2, '0'), ":").concat(secs.padStart(2, '0'));
};

var CooldownButton = function CooldownButton(_ref) {
  var _ref$count = _ref.count,
      count = _ref$count === void 0 ? 10 : _ref$count,
      _ref$initialCount = _ref.initialCount,
      initialCount = _ref$initialCount === void 0 ? 10 : _ref$initialCount,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$cooldownClassNam = _ref.cooldownClassName,
      cooldownClassName = _ref$cooldownClassNam === void 0 ? '' : _ref$cooldownClassNam,
      _ref$readyClassName = _ref.readyClassName,
      readyClassName = _ref$readyClassName === void 0 ? '' : _ref$readyClassName,
      _ref$cooldownText = _ref.cooldownText,
      cooldownText = _ref$cooldownText === void 0 ? 'Resend code in' : _ref$cooldownText,
      _ref$readyText = _ref.readyText,
      readyText = _ref$readyText === void 0 ? 'Resend code' : _ref$readyText,
      onClick = _ref.onClick,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["count", "initialCount", "disabled", "cooldownClassName", "readyClassName", "cooldownText", "readyText", "onClick"]);
  var theme = (0, _ThemeProvider.useTheme)();
  var classes = useStyles({
    theme: theme
  });

  var _React$useState = React.useState(count),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      currentCount = _React$useState2[0],
      setCurrentCount = _React$useState2[1];

  var tick = function tick() {
    if (currentCount > 0) setTimeout(function () {
      return setCurrentCount(currentCount - 1);
    }, 1000);
  };

  React.useEffect(tick, [currentCount]);

  var handleOnClick = function handleOnClick(event) {
    if (currentCount > 0 || disabled) return;
    onClick === null || onClick === void 0 ? void 0 : onClick(event);
    setCurrentCount(initialCount);
  };

  var cooldown = /*#__PURE__*/React.createElement("div", {
    className: (0, _classnames["default"])(classes.ResendWrapper, cooldownClassName)
  }, cooldownText, " ", formatSeconds(currentCount));
  var ready = /*#__PURE__*/React.createElement(_Button["default"].Secondary, {
    disabled: disabled,
    className: readyClassName
  }, readyText);
  return /*#__PURE__*/React.createElement("div", (0, _extends2["default"])({}, rest, {
    onClick: handleOnClick
  }), currentCount > 0 ? cooldown : ready);
};

exports["default"] = CooldownButton;
//# sourceMappingURL=index.js.map